import React, { useState } from "react";
import { Button, Checkbox, Col, Form, Row } from "antd";
import CommentBox from "../../../../../inboxItemPages/components/commentBox";
import TaskCheckedList from "../../../../../inboxItemPages/components/taskCheckedList";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../../../../firebase";

function ShowingInspection({ itemId, listId, checkedItems }) {
  const isItemChecked = checkedItems[itemId.toString()]; // Convert itemId to string because keys in checkedItems are strings.

  const [isDisabled, setIsDisabled] = useState(isItemChecked);
  const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");

  function handleUndefinedValues(obj) {
    const newObj = {};
    for (let key in obj) {
      newObj[key] = obj[key] === undefined ? false : obj[key];
    }
    return newObj;
  }
  const onFinish = async (values) => {
 
    console.log("Success:", values);
    values = handleUndefinedValues(values);
    const targetDocRef = doc(assignedCollectionRef, listId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status:
                item.id == itemId && item.status == "incompleted"
                  ? "completed"
                  : item.status,
              details: item.id == itemId && values,
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
          setIsDisabled(true);
        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  return (
    <div className="item-page">
      <Form
        className="item-page-container"
        colon={false}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <h2 className="red-info-heading">
              For a property to be ready to show you must have a full inspection
              in appfolio. YOU MUST REVIEW THIS INSPECTION TO ENSURE THE HOME IS
              READY AND SAFE TO BE VIEWED.
            </h2>
          </Col>
          <Col span={24}>
            <p className="blue-heading">
              -if there are items that need to be repaired check first with the
              make ready vendor to see if they missed or did not complete
            </p>
          </Col>
          <Col span={24}>
            <p className="blue-heading">
              -if not on their list contact the property owner and set up for
              one of our vendors to complete the items so it can be showed.
            </p>
          </Col>
          <Col span={24}>
            <h2 className="green-heading">
              When you receive notice that the property is ready to show it must
              be listed with a codebox in place in 2 business days or less. If
              Gina is not able to assist with this make time to go yourself to
              place a codebox and have the home ready to show.
            </h2>
          </Col>
          <Col span={24}>
            <h3 className="green-heading">
              Make sure and update the "manage physical lockbox" page in
              appfolio with the codebox you placed at the property.
            </h3>
          </Col>
          <Col span={24}>
            <h1 className="red-info-heading">
              When you check this step compete it will start a checklist for
              support staff to inspect the home while listed for rent.
            </h1>
          </Col>
          <Col span={24}>
            <h1 className="red-info-heading">
              This will also start a checklist for you to follow up with the
              owner every 2 weeks on price adjustments.
            </h1>
          </Col>
          <Col span={24}>
            <Form.Item label="1" name="getListingPics" valuePropName="checked">
              <Checkbox>
                Get listing pics - if pro needed refer to the process and
                procedures for details on nested tours or the checkbox above
              </Checkbox>
            </Form.Item>
            <Form.Item label="2" name="finalInspection" valuePropName="checked">
              <Checkbox>
                Do final inspection -see inspect property step above
              </Checkbox>
            </Form.Item>
            <Form.Item label="3" name="updateCodeBox" valuePropName="checked">
              <Checkbox>
                Update codebox in sayeagle if you have not already
              </Checkbox>
            </Form.Item>
            <Form.Item
              label="4"
              name="removeComingSoonList"
              valuePropName="checked"
            >
              <Checkbox>
                Remove coming soon from listing title and edit available date in
                appfolio to enable showings.
              </Checkbox>
            </Form.Item>
            <Form.Item label="5" name="readyToShow" valuePropName="checked">
              <Checkbox>
                Make sure the ready to show date is updated in appfolio
              </Checkbox>
            </Form.Item>
            <Form.Item label="6" name="ownerReport" valuePropName="checked">
              <Checkbox>
                Set up owner report in tenant turner DO NOT INCLUDE FEEDBACK -
                MAKE SURE AND ADD THE OWNERS EMAIL ADDRESS OTHERWISE THEY WILL
                NOT GET THE REPORT!
              </Checkbox>
            </Form.Item>
            <Form.Item label="7" name="sendReport" valuePropName="checked">
              <Checkbox>
                Also have this report sent to{" "}
                <span className="onclick-text">gina@integrityokc.com</span>
              </Checkbox>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Row justify="end" gutter={[8, 0]}>
              <Col>
                <Button>Skip</Button>
              </Col>
              <Col>
                <Button type="primary" htmlType="submit" disabled={isDisabled}>
                  Completed
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <CommentBox />
          </Col>
          <Col span={24}>
            <TaskCheckedList />
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default ShowingInspection;
